module.exports = "<div class=\"row site-header vertical-align\"> <div class=col-xs-3> <span class=icon-unordered-list></span> <a ui-sref=app.home translate>Home</a> </div> <div class=col-xs-3> <app-widgets-login></app-widgets-login> </div> <div class=col-xs-2> <span ng-repeat=\"language in $ctrl.languages\"> <a ui-state=$ctrl.$state.$current.name ui-state-params=\"{lang: language}\" class=language-switch ng-class=\"{ disabled: language == $ctrl.currentLanguage }\">{{ language }}</a> </span> </div> <div class=col-xs-4> <div class=sac-logo></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/header/partial.html
// module id = 543
// module chunks = 0